export function TeamHub() {
  return (
    <div className="space-y-10">

      {/* PAGE HEADER */}
      <div>
        <h1 className="text-3xl font-bold mb-2">Team Hub</h1>
        <p className="text-muted">
          Internal intelligence for your roster, roles, performance, and availability.
        </p>
      </div>

      {/* GRID LAYOUT */}
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">

        {/* LEFT COLUMN */}
        <div className="space-y-8">

          {/* ROSTER */}
          <section className="bg-surface border border-border rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4">Roster</h2>

            <div className="space-y-4">
              {/* PLAYER CARD */}
              <div className="flex items-center justify-between bg-bg p-3 rounded-md border border-border">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-[#1F242C]" />
                  <div>
                    <p className="font-medium">Player Name</p>
                    <p className="text-xs text-muted">Rifler</p>
                  </div>
                </div>
                <p className="text-[#4FC3F7] font-semibold">ELO: 2500</p>
              </div>

              <div className="flex items-center justify-between bg-bg p-3 rounded-md border border-border">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-[#1F242C]" />
                  <div>
                    <p className="font-medium">Player Name</p>
                    <p className="text-xs text-muted">AWPer</p>
                  </div>
                </div>
                <p className="text-[#4FC3F7] font-semibold">ELO: 2300</p>
              </div>

              {/* Add more players dynamically later */}
            </div>
          </section>

          {/* AVAILABILITY */}
          <section className="bg-surface border border-border rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4">Availability</h2>

            <div className="space-y-3">
              <div className="flex justify-between">
                <p className="text-sm">Player Name</p>
                <span className="text-green-400 font-medium">Available</span>
              </div>

              <div className="flex justify-between">
                <p className="text-sm">Player Name</p>
                <span className="text-yellow-400 font-medium">Uncertain</span>
              </div>

              <div className="flex justify-between">
                <p className="text-sm">Player Name</p>
                <span className="text-red-400 font-medium">Unavailable</span>
              </div>
            </div>
          </section>

        </div>

        {/* MIDDLE COLUMN */}
        <div className="space-y-8">

          {/* TEAM PERFORMANCE */}
          <section className="bg-surface border border-border rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4">Season Performance</h2>

            <div className="space-y-4">
              <div className="flex justify-between">
                <p className="text-muted">Current Record</p>
                <p className="font-semibold">8 - 3</p>
              </div>

              <div className="flex justify-between">
                <p className="text-muted">Win Rate</p>
                <p className="font-semibold">72%</p>
              </div>

              <div className="flex justify-between">
                <p className="text-muted">Avg Opponent ELO</p>
                <p className="font-semibold">2250</p>
              </div>

              <div className="flex justify-between">
                <p className="text-muted">Lineup Stability</p>
                <p className="font-semibold">High</p>
              </div>
            </div>
          </section>

          {/* MAP POOL */}
          <section className="bg-surface border border-border rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4">Map Pool</h2>

            <div className="space-y-3">
              <div className="flex justify-between">
                <p>Mirage</p>
                <span className="text-[#4FC3F7] font-medium">Strong</span>
              </div>

              <div className="flex justify-between">
                <p>Inferno</p>
                <span className="text-yellow-400 font-medium">Average</span>
              </div>

              <div className="flex justify-between">
                <p>Nuke</p>
                <span className="text-red-400 font-medium">Weak</span>
              </div>
            </div>
          </section>

        </div>

        {/* RIGHT COLUMN */}
        <div className="space-y-8">

          {/* RECENT MATCHES */}
          <section className="bg-surface border border-border rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4">Recent Matches</h2>

            <div className="space-y-4">
              <div className="flex justify-between bg-bg p-3 rounded-md border border-border">
                <p className="text-sm">vs Team XYZ</p>
                <span className="text-green-400 font-medium">Win</span>
              </div>

              <div className="flex justify-between bg-bg p-3 rounded-md border border-border">
                <p className="text-sm">vs Team ABC</p>
                <span className="text-red-400 font-medium">Loss</span>
              </div>
            </div>
          </section>

          {/* TEAM NOTES */}
          <section className="bg-surface border border-border rounded-lg p-6">
            <h2 className="text-xl font-semibold mb-4">Team Notes</h2>

            <textarea
              placeholder="Write internal notes for your team..."
              className="
                w-full h-40 bg-bg border border-border rounded-md p-3
                focus:outline-none focus:border-[#4FC3F7]
              "
            />
          </section>

        </div>

      </div>
    </div>
  );
}